<template>
  <div>
    <section class="container content">
      <div class="breadcrumb d-flex">
        <div class="flex-grow-1">
          <nuxt-link :to="localePath('/')">Home</nuxt-link>
          <span class="breadcrumb--separator">></span>
          {{ $t('Unterstütze Lernpfad') }}
        </div>
      </div>

      <h2>
        {{
          $t(
            'Unterstütze uns!'
          )
        }}
      </h2>
      <p>
        Um die Kosten für den Betrieb, den Support und die Weiterentwicklung künftig decken zu können, sind wir auf deine Unterstützung angewiesen!
        Wir bedanken uns schon im Voraus für deinen Beitrag. 
        </br></br>
      </p>
      <div>
        <div class="rnw-widget-container"></div>
      </div>
    </section>
  </div>
</template>

<script>
import { ampli } from '../mixins/Amplitude/index.js'

export default {
  components: {},

  mixins: [ampli],

  scrollToTop: true,

  head() {
    return {
      title: this.$i18n.t('Über uns | Lernpfad'),
    }
  },
  created() {
    ampli.teamPageViewed()
  },
  mounted() {
    const tamaroScript = document.createElement('script')
    tamaroScript.setAttribute(
      'src',
      'https://tamaro.raisenow.com/lernp-990e/latest/widget.js'
    )
    document.head.appendChild(tamaroScript)

    let recaptchaScriptIsReady = false
    const checkInterval = setInterval(function () {
      if (window.rnw.tamaro) {
        recaptchaScriptIsReady = true
        clearInterval(checkInterval)
        window.rnw.tamaro.runWidget('.rnw-widget-container', {
          language: 'de',

          amounts: [
    {
       "if": "paymentType() == onetime",
       "then": [29,49,69,89],
    },
    {
       "if": "paymentType() == recurring && recurringInterval() == monthly",
       "then": [6,8,10,12],
    },
    {
       "if": "paymentType() == recurring && recurringInterval() == quarterly",
       "then": [18,24,30,36],
    },
    {
       "if": "paymentType() == recurring && recurringInterval() == semestral",
       "then": [36,48,60,72],
    },
    {
       "if": "paymentType() == recurring && recurringInterval() == yearly",
       "then": [72,96,120,144],
    },
  ],

      
       

          
        })
      }
      return recaptchaScriptIsReady
    }, 500)
  },
}
</script>

<style scoped lang="scss">
@import '../assets/style/utils';

h1 {
  word-wrap: break-word;
}

h2 {
  margin: 2rem 0 1rem 0;

  @include fontSizeLineHeight(35px, 66px);
}

p {
  margin-bottom: 1rem;
}

.content {
  margin-top: 5em;
}
</style>
